export default {
    functional: true,
    render: (createElement, context) => {
        const data = {
            props: {
                mode: 'out-in'
            },
            on: {
                enter(el) {
                    const width = getComputedStyle(el).width
                    el.style.width = width
                    el.style.position = 'absolute'
                    el.style.visibility = 'hidden'
                    el.style.height = 'auto'

                    const height = getComputedStyle(el).height
                    el.style.width = null
                    el.style.position = null
                    el.style.visibility = null
                    el.style.height = 0

                    // Force repaint to make sure the
                    // animation is triggered correctly.
                    getComputedStyle(el).height
                    setTimeout(() => {
                        el.style.height = height
                    });
                },
                afterEnter(el) {
                    el.style.height = 'auto'
                },
                leave(el) {
                    const height = getComputedStyle(el).height
                    el.style.height = height

                    // Force repaint to make sure the
                    // animation is triggered correctly.
                    getComputedStyle(el).height
                    setTimeout(() => {
                        el.style.height = 0
                    });
                }
            }
        }
        return createElement('transition', data, context.children)
    },
    methods: {
        enter() {},
        leave() {}
    }
}
